import {immerable} from "immer";
import ProjectLockDto from "../interfaces/dtos/project-lock-dto.ts";

class ProjectLock {
    [immerable] = true;
    
    id: string;
    
    userLockId: string;
    
    userLockEmail: string;
    
    isLocked: boolean;
    
    constructor(dto?: ProjectLockDto) {
        if(dto) {
            this.id = dto.id;
            this.userLockId = dto.userId;
            this.userLockEmail = dto.user?.email;
            this.isLocked = dto.isLocked;
        } else {
            this.id = '';
            this.userLockId = '';
            this.userLockEmail = '';
            this.isLocked = false;   
        }
    }
    
    public lock(): void {
        this.isLocked = true;
    }
    
    public unlock(): void {
        this.isLocked = false;
    }
}

export default ProjectLock;